import React from "react";
import { Typography } from "@mui/joy";
import { ActionsMenu } from "@dreebit-registry/vsm-microservice-components";
import { WidgetActionsMenu } from "../WidgetActionsMenu";

interface WidgetHeaderProps {
  title: string | React.ReactNode;
  onDelete: () => void;
  onEdit: () => void;
}

const WidgetHeader: React.FC<WidgetHeaderProps> = ({ title, onDelete, onEdit }) => {
  const actionItems = WidgetActionsMenu(onDelete, onEdit);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Typography level="titleSmallLight" sx={{ flex: 1, textAlign: "left", paddingLeft: "10px", color: "#333" }}>
        {title}
      </Typography>
      <div className="no-drag">
        <ActionsMenu items={actionItems} />
      </div>
    </div>
  );
};

export default WidgetHeader;
